export default __webpack_public_path__ + "static/media/noche.8b3c28a8.svg";